import {useNuxtApp} from 'nuxt/app'
import {defineStore} from 'pinia'
import {ref} from 'vue'
import {useNotification} from '@/composables/useNotification'
import {$larafetch} from '@/utils/$larafetch'
import {useSlideOverStore} from "~/store/slideOver"
import {useStatic} from "~/store/static"

export const useProcessGroupsStore = defineStore('processGroups', () => {
    const staticStore = useStatic()
    const slideOverStore = useSlideOverStore()

    const processesGroupedByEvent = ref([])
    const processesGroupedByFundingProgram = ref([])
    const processGroupsLoading = ref(false)

    function fetchProcessGroups() {
        if (!staticStore.activeYear?.id) {
            return
        }

        processGroupsLoading.value = true

        $larafetch(useNuxtApp().$apiRoute("spa.processes.processGroups.index"), {
            params: {
                year_id: staticStore.activeYear?.id
            }
        }).then(response => {
            processesGroupedByEvent.value = response.groupedByEvent
            processesGroupedByFundingProgram.value = response.groupedByFundingProgram
        }).catch(error => {
            const notification = useNotification()
            const app = useNuxtApp()
            if (error && error.response && error.response.status === 422) {
                notification.error(app.$i18n.t('invalidRequestData'))
            } else if (error && error.response && error.response.status === 404) {
                notification.error(app.$i18n.t('modelDoesNotExist'))
            } else {
                if (error && error.response?._data.message) {
                    notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data.message)
                } else if (error && error.response?._data) {
                    notification.error(app.$i18n.t('generalRequestError') + '\n' + error.response._data)
                } else {
                    notification.error(app.$i18n.t('generalRequestError'))
                }
            }
        }).finally(() => {
            processGroupsLoading.value = false
        })
    }

    function addNewProcess(context, id, contextData = null) {
        slideOverStore.setSlideOverOpen(true)
        slideOverStore.setTitle('menu.fundingPrograms')
        slideOverStore.setDescription('fundingPrograms.slideOver.description')
        slideOverStore.setComponent('FundingProgramsSelection')

        if (context === 'event') {
            slideOverStore.setContext({type: 'event', id: id, yearId: contextData.year_id, data: contextData})
        } else if (context === 'fundingProgram') {
            slideOverStore.setContext({filters: [{column: 'funding_program_id', operator: '=', value: id}]})
        } else {
            slideOverStore.setContext(null)
        }
    }

    return {
        processesGroupedByEvent,
        processesGroupedByFundingProgram,
        processGroupsLoading,
        addNewProcess,
        fetchProcessGroups
    }
})



